module.exports = __webpack_public_path__ + "img/Parsian.de12be44.svg";